import { MemberGroupsContext } from '@bo-hooks/memberGroups/useMemberGroupsContext';
import { ResetIconButton } from '@library/components/buttons';
import { Searchbar } from '@library/components/inputs';
import { useContext } from 'react';

export function MemberGroupsFilters() {
  const { filters, setFilter, resetFilters } = useContext(MemberGroupsContext);

  return (
    <div className="flex items-center gap-4">
      <Searchbar
        handleSearch={(value) => setFilter('name', value)}
        id="search-by-name"
        placeholder="Search by group name"
        searchValue={filters.name}
      />
      <Searchbar
        handleSearch={(value) => setFilter('description', value)}
        id="search-by-description"
        placeholder="Search by description"
        searchValue={filters.description}
      />
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 !p-0"
        disabled={false}
        label="Reset Filters"
        onClick={resetFilters}
      />
    </div>
  );
}
